<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div v-if="checkQuoteOrAppointment" class="p-mt-6 p-mb-5 text-title">
      Choisissez un centre et votre créneau
    </div>
    <div v-else class="p-mt-6 p-mb-5 text-title">
      Choisissez un centre
    </div>

    <p class="text-title-green">Votre centre 123 Pare-Brise</p>
    <small v-if="v$.center.$invalid && v$.center.$dirty" class="p-error">
      Veuillez selectionner un centre
    </small>
    <small
      v-if="validationQuote$.center.$invalid && validationQuote$.center.$dirty"
      class="p-error"
    >
      Veuillez selectionner un centre
    </small>
    <Dropdown
      ref="dropdown"
      v-on:keydown.enter="removeKeyboard()"
      filter
      v-model="center"
      :options="appointmentStore.agencies"
      optionLabel="URL_NOM_BU"
      placeholder="Choisissez votre centre"
      id="agencies-list"
    />

    <div v-if="checkQuoteOrAppointment">
      <p class="text-title-green">Date souhaitée</p>
      <small
        v-if="v$.appointmentDate.$invalid && v$.appointmentDate.$dirty"
        class="p-error"
      >
        Veuillez selectionner une date
      </small>
      <Calendar
        class="p-d-flex p-jc-center"
        v-model="appointmentDate"
        :minDate="minDateValue"
        :disabledDays="[0]"
        id="date-picker"
      />

      <small v-if="v$.timeslot.$invalid && v$.timeslot.$dirty" class="p-error">
        Veuillez selectionner un créneau
      </small>
      <div class="p-d-inline-flex p-jc-between p-my-3" style="width: 90%">
        <div class="timeslotSelectorItem">
          <RadioButton
            id="morning"
            name="timeslot"
            value="morning"
            v-model="timeslot"
            class="p-my-3 p-my-sm-3"
          />
          <label for="morning" class="text-option">&nbsp;Matin</label>
        </div>
        <div class="timeslotSelectorItem">
          <RadioButton
            id="afternoon"
            name="timeslot"
            value="afternoon"
            v-model="timeslot"
            class="p-my-3 p-my-sm-3"
          />
          <label for="afternoon" class="text-option">&nbsp;Après-midi</label>
        </div>
      </div>
    </div>

    <div class="p-d-inline-flex p-jc-center p-my-3" style="width: 60%">
      <div class="p-mt-sm-3 p-mr-5">
        <Button class="button-navigate button-back" @click="onPrevious">Précédent</Button>
      </div>
      <div class="p-mt-sm-3">
        <Button class="button-navigate" @click="onNext">Suivant</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref, onMounted } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { moment } from "../utils";

export default {
  name: "StepAppointment",
  setup(props, { emit }) {
    onBeforeMount(async() => {
      await appointmentStore.fetchAgencies();
      for (const agency of appointmentStore.agencies) {
        if (agency.ID_SOCIETE == localStorage.company_id) {
          center.value = agency;
          break;
        }
      }
    });

    const removeKeyboard = () => {
      document.getElementById('agencies-list').blur()
    };
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const center = ref(null);
    const timeslot = ref(null);
    const appointmentDate = ref(null);

    const checkQuoteOrAppointment = computed(() => {
      if (appointmentStore.appointment.request_type !== "quote") {
        return true;
      } else {
        return false;
      }
    });

    const rules = {
      timeslot: { required },
      appointmentDate: { required },
      center: { required },
    };

    const rulesQuote = {
      center: { required },
    };

    const v$ = useVuelidate(rules, {
      timeslot,
      appointmentDate,
      center,
    });

    const validationQuote$ = useVuelidate(rulesQuote, {
      center,
    });

    const onPrevious = () => {
      emit("prevPage", menuStore.currentMenuItem);
    };

    const onNext = () => {
      const nextUrl = "/verifier-mes-informations";
      const target = menuStore.getMenuItemWithUrl(nextUrl);
      target.parent = menuStore.currentMenuItem.to;

      let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/mon-rendez-vous',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };

      if (checkQuoteOrAppointment.value) {
        v$.value.$touch();
        if (!v$.value.$error) {
          appointmentStore.appointment.appointment_date = appointmentDate.value;
          appointmentStore.appointment.appointment_time = timeslot.value;
          appointmentStore.appointment.point_of_sale_id = center.value.ID_SOCIETE;
          appointmentStore.other_information.point_of_sale_name = center.value.URL_NOM_BU;

          if (appointmentStore.appointment.appointment_date) dataLayerToPush.appointment_date = moment(appointmentStore.appointment.appointment_date).format("YYYY-MM-DD");
          if (appointmentStore.appointment.appointment_time) dataLayerToPush.appointment_time = appointmentStore.appointment.appointment_time;
          if (appointmentStore.appointment.point_of_sale_id) dataLayerToPush.point_of_sale_id = appointmentStore.appointment.point_of_sale_id;
          if (appointmentStore.other_information.point_of_sale_name) dataLayerToPush.other_point_of_sale_name = appointmentStore.other_information.point_of_sale_name;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(dataLayerToPush);

          emit("nextPage", target);
        }
      } else {
        validationQuote$.value.$touch();
        if (!validationQuote$.value.$error) {
          appointmentStore.appointment.point_of_sale_id = center.value.ID_SOCIETE;
          appointmentStore.other_information.point_of_sale_name = center.value.URL_NOM_BU;

          if (appointmentStore.appointment.point_of_sale_id) dataLayerToPush.point_of_sale_id = appointmentStore.appointment.point_of_sale_id;
          if (appointmentStore.other_information.point_of_sale_name) dataLayerToPush.other_point_of_sale_name = appointmentStore.other_information.point_of_sale_name;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(dataLayerToPush);

          emit("nextPage", target);
        }
      }
    };

    const minDateValue = new Date();

    const dropdown = ref(null);

    onMounted(() => {
        dropdown.value.onFilterChange = (event) => {
            const value = event.target.value.trim();
            dropdown.value.filterValue = value;
            dropdown.value.focusedOptionIndex = -1;
            dropdown.value.$emit('filter', { originalEvent: event, value });
            !dropdown.value.virtualScrollerDisabled &&
            dropdown.value.virtualScroller.scrollToIndex(0);
        };
    });

    return {
      onPrevious,
      onNext,
      center,
      appointmentStore,
      timeslot,
      v$,
      validationQuote$,
      appointmentDate,
      minDateValue,
      checkQuoteOrAppointment,
      removeKeyboard,
      dropdown,
    };
  },
};
</script>

<style scoped>
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  ::v-deep(.timeslotSelectorItem .text-option) {
    margin-top : 12px !important;
  }
}
.p-dropdown { /* force border of dropdown to show */
  border: 1px solid #a6a6a6 !important;
}
</style>

<style>
#agencies-list {
  width: 60%;
  text-align: center;
}
.text-title-green {
  color: #24a285 !important;
  font-size: 1.8em !important;
  text-align: center !important;
  padding: 25px 15px !important;
}
.timeslotSelectorItem {
  display: flex;
  justify-content: center;
  align-items: center;
}
input#date-picker {
  text-align: center;
}

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .text-title-green {
    font-size: 1.25rem !important;
  }
  #agencies-list {
    width: 100%;
    text-align: center;
  }
}
</style>
